<h2 mat-dialog-title></h2>
<mat-dialog-content>
    <div>
        <iframe width="100%" [src]="photoURL(videoUrl)"
            title="YouTube video player" frameborder="0"
           
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> </div>
    <div mat-dialog-actions align="end">
        <button type="button" mat-raised-button (click)="onNoClick()">Close</button>
        
    </div>
</mat-dialog-content>